import isDateInPast from './isDateInPast'

export const tsaPrecheckPromotionalPrice = Number(0.0).toFixed(2)

export const tsaPrecheckClearBundlePrice = 209

export const tsaPrecheckClearRenewBundlePrice = 209

export const clearMembershipPrice = 209

export const stringifyPrice = (price: number) => {
  return ` $${price}`
}
export const isFamDiscountExpired = isDateInPast('2025-12-31')
